import React, {FunctionComponent, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {RouteComponentProps} from 'react-router-dom';
import {Link, useHistory} from 'react-router-dom';

import ManageFoldersComponent from '../component/folder/ManageFoldersComponent'
import FooterComponent from "../component/footer/FooterComponent";
import HeaderLightComponent from "../component/header/HeaderLightComponent";

import Back from '../component/svg/Back';
import SelectForm from '../component/form/SelectForm';

type Params = {
  state: string
  currentPage: string
};

const ManageFolder: FunctionComponent<RouteComponentProps<Params>> = ({match}) => {
  const { t } = useTranslation()
  const history = useHistory()

  const [term, setTerm] = useState<string>('');
  const [selectedForm, setSelectedForm] = useState<string|null>(null)

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setTerm((e.target.value).toLowerCase());
  }

  const title = match?.params?.state !== undefined ? t(`dashboard.integration-state.${match.params.state}`) : t('common.folders')

  const [role] = useState<string>(localStorage.getItem('role') ?? '');

  const previousPage = localStorage.getItem("previousPage") || "/tableau-de-bord";

  if (role !== 'manage_dossier') {
    window.location.pathname = '/'
  }

  return (
    <div>
      <HeaderLightComponent />
          <>
            <div className="wrap u-mxAuto">
              <div className="flex-container">
                <div className="col-md-12">
                  <Link to="#" onClick={(event) => {
                    event.preventDefault();
                    history.push(previousPage)
                  }}>
                    <Back color="var(--ink-1)" />
                    <span className="u-txt-size-s u-txt-color-ink-1 u-mxs">{t('button.back')}</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="wrap u-mxAuto">
              <div className="flex-container">
                <div className="col-md-5">
                  <h2 className="h3 u-mbs" dangerouslySetInnerHTML={{__html: title}}/>
                </div>
                <div className="col-md-7">
                  <div className='flex-container'>
                    <div className="col-md-5">
                      <SelectForm onSelectChange={(formId: string|null) => setSelectedForm(formId)} folderState={match?.params?.state ?? 'undefined'}/>
                    </div>
                    <div className="col-md-7">
                      <input type="text" onChange={e => handleSearchInputChange(e)} style={{boxShadow: `0px 5px 8px rgb(0 0 0 / 10%)`}} placeholder={t('common.search')} className="button-search" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="min-height-content-folder">
              <div className="box-elevations box-elevations--base box-elevations--max-heigt-initial box-elevations--mb u-mxAuto">
                <ManageFoldersComponent term={term} state={match?.params?.state} formId={selectedForm} />
              </div>
            </div>
          </>
      <FooterComponent />
    </div>
  );
}

export default ManageFolder;
